
import React, { useEffect, useState } from 'react';
import styles from '../styles/countrypage.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import CustomImage from "./CustomImage";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import FeaturedBlogs from "./FeaturedBlogs";
import NeedGuidance from './NeedGuidance';
import CustomLink from './CustomLink';
import Testimonial from './Testimonial';
import fetchUtil from '../utils/fetchUtil';
import Button from 'react-bootstrap/Button';
import KcNewLatestUpdates from './kcNewlatestupdates';
import FaqComponent from './PST/FrequentlyAskedQuestions';
import VideoTestimonials from './PST/VideoTestimonials';
import { countries } from '../utils/constants';
import { getSlugFromCountry, isFrappeOrJotFormClass } from '../utils/helpers';
import router from 'next/router';
import NewNeedGuidance from './NewNeedGuidance';
import Head from 'next/head';
import LazyReveal from './LazyReveal';
import useIsMobile from '../hooks/useIsMobile';

const Countrypage: React.FC = (props: any) => {
  const [popularUniversities, setPopularUniversities] = useState<any>([]);
  const countryData = props.pageData[0];
  const countrySlug = countryData?.name === 'UK' ? 'uk' : getSlugFromCountry(countryData?.name, countries);
  const isMobile = useIsMobile(480);
  useEffect(() => {
    if (countryData?.name) {
      const countryName = countryData?.name === 'UnitedKingdom' ? 'UK' : countryData?.name
      fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/universities?country=${countryName.replace(/ /g, '')}&_start=0&_limit=10&_sort=priority:ASC`, 'GET', {}, '', false)
        .then((res) => setPopularUniversities(res))
    }
  }, [countryData])


  return (
    <>
      <Head>
        {
          countryData?.newTopImages?.length > 0 &&
          <link rel="preload" href={countryData?.newTopImages[0]?.imageUrl} as="image" fetchpriority="high" />
        }
      </Head>
      <div className={styles.edtech}>
        <Container>
          <div id='country-heading' className={styles.breadcrum}>
            <Row className="text-center">
              <Col lg={9} md={9} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item style={{ opacity: 0.5 }} href="/study-destinations">Study Destination</Breadcrumb.Item>
                  <Breadcrumb.Item href="">{countryData?.name}</Breadcrumb.Item>
                </Breadcrumb>
                <div className={styles.abttopContent}>
                  <h1> Study In {countryData?.name} </h1>
                </div>
                <Row>
                  {
                    countryData.newTopImages?.length > 0
                      ? (isMobile ?  [{...countryData?.newTopImages[0]}] : countryData.newTopImages).map((image: any, ind: number) =>
                        <Col xs={12} md={6} className={ind === 1 ? styles.hideimg : ''}>
                          <div className={styles.imgContainer}>
                            <CustomImage src={image?.imageUrl} width={770} alt={image.alt} height={500} />
                          </div>
                        </Col>
                      )
                      : <>
                        <Col xs={12} md={6}>
                          <CustomImage src="/canadaa.svg" width={770} height={500} alt="canadaa" />
                        </Col>
                        <Col xs={12} md={6}>
                          <CustomImage src="/canadab.svg" width={770} height={500} alt="canadab" />
                        </Col>
                      </>
                  }
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container id='contry-discription' className={styles.sectionBorder}>
        <Row>
          <Col sm={12} xs={12} md={12}>
            <div className={styles.centerContent}>
              {countryData?.description}
            </div>
          </Col>
        </Row>
        <div className={styles.enquireBtn}>
          <Button variant="primary" size="lg" onClick={() => {
            !countryData?.meta?.jotforms[0]?.jotformid && router.push(countryData?.externalLink)
          }}
            className={`${countryData?.meta?.jotforms[0]?.jotformid
              ? `btn ${isFrappeOrJotFormClass(countryData?.meta?.jotforms[0]?.jotformid)}`
              : ''
              }`}
          >
            {countryData?.bannerBtnText || 'Enquire Now'}
          </Button>
        </div>
      </Container>

      <LazyReveal id='study-content' className={styles.studyContent}>
        <Container>
          <Row>
            <Col xs={12} lg={6}>
              <div className={styles.service_content}>
                <div className={styles.content}>
                  <h2 className={styles.h2title}>Why Study in {countryData?.name}?</h2>
                  <div style={{ textAlign: 'justify' }}>{countryData?.whyStudy}</div>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6} >
              <div className={styles.offers}>
                <h3>Quick facts</h3>
                <ul>
                  {countryData?.quickFacts?.length > 0 &&
                    countryData?.quickFacts.map((item: any, index: number) => (
                      <li key={item?.id ?? index}>
                        {typeof item === 'string' ? item : item?.fact}
                      </li>
                    ))
                  }
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <div className={styles.costOfeduSection}>
          <div className="d-none d-sm-block">
            <div className={styles.costofEducation}>
              <Container>
                <h2>Cost of Studying in {countryData?.name}</h2>
                <Row>
                  <Col>
                    <Table>
                      <thead>
                        <tr className={styles.headtr}>
                          <th>Types of Expenses</th>
                          <th colSpan={2}>Annual Expenses in {countryData?.currency}</th>
                        </tr>
                        {countryData?.costOfEducation[0].diploma && <tr className={styles.headsmalltr}>
                          <th>&nbsp;</th>
                          <th>Diploma</th>
                          <th>Degree</th>
                        </tr>}
                      </thead>
                      <tbody className={styles.customtr}>
                        {countryData?.costOfEducation?.length > 0 &&
                          countryData?.costOfEducation.map((expense: any) => {
                            return (
                              !expense.isTotal
                                ? <tr id={expense.id}>
                                  <td>{expense.expenseType}</td>
                                  {expense.diploma && <td>{expense.diploma}</td>}
                                  <td>{expense.degree}</td>
                                </tr>
                                : <tr id={expense.id} className={styles.headsmalltr}>
                                  <th>{expense.expenseType}</th>
                                  {expense.diploma && <th>{expense.diploma}</th>}
                                  <th>{expense.degree}</th>
                                </tr>
                            )
                          })
                        }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="d-block d-sm-none">
            <div className={styles.costofEducation}>
              <div className={styles.costofEducation}>
                <Container>
                  <h2>Cost of Studying in  {countryData?.name}</h2>
                  <Row>
                    <Table>
                      <thead>
                        <tr className={styles.headtr}>
                          <th colSpan={2}>Types of Expenses</th>
                        </tr>
                      </thead>
                    </Table>
                    {countryData?.costOfEducation[0].diploma ? <Tabs defaultActiveKey="diplo" className={styles.recogTabs}>
                      <Tab eventKey="diplo" title="Diploma" className={styles.custtab}>
                        <Table>
                          <tbody className={styles.customtr}>
                            {countryData?.costOfEducation?.length > 0 &&
                              countryData?.costOfEducation.map((expense: any, index: number) => {
                                return (
                                  !expense.isTotal
                                    ? <tr id={expense.id}>
                                      <td>{expense.expenseType}</td>
                                      <td>{expense.diploma}</td>
                                    </tr>
                                    : <tr id={expense.id} className={styles.headsmalltr}>
                                      <th>{expense.expenseType}</th>
                                      <th>{expense.diploma}</th>
                                    </tr>
                                )
                              })
                            }
                          </tbody>
                        </Table>
                      </Tab>
                      <Tab eventKey="Degr" title="Degree" className={styles.custtab}>
                        <Table>
                          <tbody className={styles.customtr}>
                            {countryData?.costOfEducation?.length > 0 &&
                              countryData?.costOfEducation.map((expense: any) => {
                                return (
                                  !expense.isTotal
                                    ? <tr id={expense.id}>
                                      <td>{expense.expenseType}</td>
                                      <td>{expense.degree}</td>
                                    </tr>
                                    : <tr id={expense.id} className={styles.headsmalltr}>
                                      <th>{expense.expenseType}</th>
                                      <th>{expense.degree}</th>
                                    </tr>
                                )
                              })
                            }
                          </tbody>
                        </Table>
                      </Tab>
                    </Tabs>
                      : <Table>
                        <tbody className={styles.customtr}>
                          {countryData?.costOfEducation?.length > 0 &&
                            countryData?.costOfEducation.map((expense: any) => {
                              return (
                                !expense.isTotal
                                  ? <tr id={expense.id}>
                                    <td>{expense.expenseType}</td>
                                    <td>{expense.degree}</td>
                                  </tr>
                                  : <tr id={expense.id} className={styles.headsmalltr}>
                                    <th>{expense.expenseType}</th>
                                    <th>{expense.degree}</th>
                                  </tr>
                              )
                            })
                          }
                        </tbody>
                      </Table>}
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </div>
        <Container>
          <Row>
            <Col xs={12} lg={6} sm={6} >
              <div className={styles.imgRestructured}>
                {
                  countryData.newInsightsImages?.length > 0 &&
                  countryData.newInsightsImages.map((image: any, index: number) =>
                    <div className={index === 0 ? styles.picA : styles.picB}>
                      <CustomImage src={image.imageUrl} alt={image.alt} width={250} height={350} />
                    </div>
                  )
                }
              </div>
            </Col>
            <Col xs={12} lg={6} sm={6} className={styles.indusContent}>
              <div className={styles.service_content}>
                <div className={styles.content} >
                  <h3>Careers & Industry Insights</h3>
                  <div style={{ textAlign: 'justify' }}>{countryData?.insights}</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </LazyReveal>

      {popularUniversities.length > 0 &&
        <LazyReveal id='popular-universities' className={styles.popularUniversities}>
          <Container>
            <h2>Popular Universities in {countryData?.name}</h2>
            <Row>
              <Col xs={12} lg={6}>
                <ul>
                  {
                    popularUniversities.map((univ: any, index: number) =>
                      index % 2 === 0 && <li key={index}>
                        <CustomImage src={univ?.image?.imageUrl || '/'} alt={univ?.image?.alt || 'university'} width={70} height={70} />
                        <p>{univ?.name}</p>
                      </li>)
                  }
                </ul>
              </Col>
              <Col xs={12} lg={6}>
                <ul>
                  {
                    popularUniversities.map((univ: any, index: number) =>
                      index % 2 !== 0 && <li key={index}>
                        <CustomImage src={univ?.image?.imageUrl || '/'} alt={univ?.image?.alt || 'university'} width={70} height={70} />
                        <p> {univ?.name}</p>
                      </li>)
                  }
                </ul>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row className="text-center mt-5">
              <Col>
                <a href={`/universities/${countrySlug}`} className={styles.viewMore}> View More </a>
              </Col>
            </Row>
          </Container>
        </LazyReveal>}

      <LazyReveal id='popular-courses' className={styles.popularCourses}>
        <Container className={styles.containerSpace} >
          <Row>
            <Col xs={12} lg={6} md={6}>
              <CustomImage
                src={`${process.env.NEXT_PUBLIC_ASSET_URL}/Popular_Courses_8a19985908.svg`}
                alt="popularCourses.svg" width={490} height={440} />
            </Col>
            <Col xs={12} lg={6} md={6} >
              <div className={styles.popcourse}>
                <h3>Popular Courses in {countryData?.name} </h3>
                <ul>
                  {
                    countryData?.popularCourses?.length > 0 &&
                    countryData?.popularCourses.map((course: any, index: number) =>
                      <li key={index}><div className={styles.starimg} ><CustomImage src="/new-images/star-coursees.svg" alt="StarCoursees.svg" width={17} height={17} /></div>{course}</li>
                    )
                  }
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className={styles.containerSpace} >
          <Row>
            <Col xs={12} lg={6} md={6} className={styles.impoLinktext}>
              <h3>Important Links</h3>
              <ul>
                {
                  countryData?.importantLinks?.length > 0 &&
                  countryData?.importantLinks.map((link: any, index: number) =>
                    <CustomLink data={link}>
                      <li key={index}>
                        <CustomImage src="/new-images/imp-lines.svg" alt="impLines.svg" width={17} height={17} />
                        <h2 className={styles.h2text}>{link.label}</h2>
                        <div className={styles.morelink} ><CustomImage src="/new-images/more-link-arrow.svg" alt="moreLinkArrow.svg" width={24} height={22} /></div>
                      </li>
                    </CustomLink>
                  )
                }
              </ul>
            </Col>
            <Col xs={12} lg={6} md={6} className={styles.impoLinkImg}>
              <CustomImage
                src={`${process.env.NEXT_PUBLIC_ASSET_URL}/Important_Links_b99b9b7010.svg`}
                alt="importantlink.svg" width={490} height={440} />
            </Col>
          </Row>
        </Container>
      </LazyReveal>
      {
        countryData?.student_testimonials?.length > 0 &&
        <Testimonial data={countryData?.student_testimonials?.sort((firstTestimonial: any, secondTestimonial: any) => secondTestimonial.id - firstTestimonial.id)?.slice(0, 15)} title='Our students love us' bgColor='#ffffff' />
      }
      {countryData?.videoTestimonial &&
        <VideoTestimonials {...countryData.videoTestimonial} />}
      <LazyReveal className={styles.homePageLatestKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </LazyReveal>
      <LazyReveal className={styles.homePageBlogs}>
        <div className={styles.countryPageBlog}>
          <FeaturedBlogs />
        </div>
        {countryData?.faq &&
          <FaqComponent {...countryData.faq} />}
      </LazyReveal>
      {countryData?.needGuidance && <NewNeedGuidance data={countryData?.needGuidance} jotforms={countryData?.meta?.jotforms} externalLink={countryData?.externalLink} />}
    </>
  )
}

export default Countrypage;